import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { formatDateTime } from '../../lib/dateFormat';

const WebhookLogs = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchLogs = async () => {
        try {
            const res = await axios.get('/api/vapi/webhook-logs');
            setLogs(res.data);
        } catch (error) {
            console.error('Failed to fetch webhook logs:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, []);

    return (
        <div className="p-6">
            <h2 className="text-2xl font-bold mb-4">🔔 Webhook Logs</h2>

            {loading ? (
                <p>Loading logs...</p>
            ) : logs.length === 0 ? (
                <div className="bg-yellow-50 border border-yellow-200 text-yellow-700 p-4 rounded">
                    <p><strong>No results found in this batch of logs.</strong></p>
                    <p>You can load another batch of logs and see if you can find what you are looking for.</p>
                </div>
            ) : (
                <div className="space-y-4">
                    {logs.map(log => (
                        <div key={log.id} className="border rounded p-3 bg-gray-50">
                            <p><strong>Event:</strong> {log.event_type}</p>
                            <p><strong>Received:</strong> {formatDateTime(log.received_at)}</p>
                            <pre className="bg-white border mt-2 p-2 rounded text-sm overflow-x-auto">
                                {JSON.stringify(log.payload, null, 2)}
                            </pre>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default WebhookLogs;
